import {FeatureState} from '../page-data/payloads/header'
import type {FeatureStates} from '../page-data/payloads/header'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'

export function useFeatureState(feature: keyof FeatureStates): FeatureState {
  const {featureStates} = useLayoutRouteData()

  return featureStates?.[feature] ?? FeatureState.Unavailable
}
